<template>
  <div class="w-100" v-bind:style="{ width: locWidth, height: locHeight }">
    <div v-if="!staticCall">
      <div
        v-if="
          !staticCall && svgData !== null && locHeight !== 0 && locWidth !== 0
        "
        v-html="svgData"
        class="svg-box"
        v-bind:style="{
          width: locWidth,
          height: locHeight,
          overflow: 'hidden'
        }"
      ></div>
    </div>
    <div
      class="svg-box"
      v-bind:style="{ width: locWidth, height: locHeight }"
      v-if="staticCall"
    >
      <img
        :src="svgUrl"
        v-bind:style="{ width: locWidth, height: locHeight }"
        v-if="
          staticCall && svgUrl !== null && locHeight !== 0 && locWidth !== 0
        "
      />
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  name: "SvgViewer",
  props: {
    src: String,
    width: String,
    height: String,
    transition: {
      type: Boolean,
      default: false
    },
    staticCall: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      svgData: null,
      svgUrl: null,
      locWidth: 0,
      locHeight: 350,
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    this.loadSvg();
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  watch: {
    src() {
      this.loadSvg();
    }
  },
  methods: {
    loadSvg() {
      if (this.staticCall) {
        this.svgUrl = null;
        setTimeout(() => {
          this.svgUrl = this.src;
          this.locWidth = this.width;
          this.locHeight = this.height;
        }, 500);
      } else {
        Axios.get(this.src).then(res => {
          const styles = `<svg width='${this.width}' height='${this.height}' `;
          const svgHtml = res.replace("<svg ", styles);
          this.svgData = svgHtml;
          this.locWidth = this.width;
          this.locHeight =
            this.window.height > 720 ? this.height : this.heigh - 50;
          this.$emit("loaded");
        });
      }
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.loadSvg();
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  /*transition: opacity 0.5s;*/
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  /*opacity: 0;*/
}
.svg-box {
  margin: 0 auto;
}
</style>
